import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Typography,
  Alert,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  LocationOn as LocationIcon,
  Public as PublicIcon,
} from "@mui/icons-material";
import { RootState, GameData, GamelistModalDetails } from "types";

import PrivateGameSearch from "./PrivateGameSearch";
import GamelistModal from "./components/GamelistModal";
import PublicCashTable from "./sections/Tables/PublicCash";
import PrivateCashTable from "./sections/Tables/PrivateCash";
import PublicTournamentTable from "./sections/Tables/PublicTournament";
import PrivateTournamentTable from "./sections/Tables/PrivateTournament";
import GamelistTabs from "./sections/GamelistTabs";

interface GamelistProps {
  setDisplay?: (display: string) => void;
}

function Gamelist({ setDisplay }: GamelistProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const locationState = useSelector((state: RootState) => state.location);
  const { city, state, country } = locationState || {};
  const user = useSelector((state: RootState) => state.user.user);

  const [gameData, setGameData] = useState<GameData>({} as GameData);
  const [modalDets, setModalDets] = useState<GamelistModalDetails>({
    open: false,
    status: "",
  });

  const getLocationStatus = () => {
    if (!country) {
      return {
        message: "You must give Local Poker permission to access your location to find great games near you",
        severity: "warning" as const,
        icon: <LocationIcon />
      };
    } else if (country !== "United States") {
      return {
        message: "Local Poker is currently only supported in the United States",
        severity: "info" as const,
        icon: <PublicIcon />
      };
    } else {
      return {
        message: `Games near ${city}, ${state}`,
        severity: "success" as const,
        icon: <LocationIcon />
      };
    }
  };

  const locationStatus = getLocationStatus();


  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      {/* Location Status */}
      <Box sx={{ mb: 3 }}>
        <Alert 
          severity={locationStatus.severity}
          icon={locationStatus.icon}
          sx={{ 
            borderRadius: 2,
            '& .MuiAlert-message': {
              fontSize: isMobile ? '0.875rem' : '1rem',
              fontWeight: 500
            }
          }}
        >
          {locationStatus.message}
        </Alert>
      </Box>

      {/* Game List Tabs */}
      <GamelistTabs setModalDets={setModalDets} setGameData={setGameData} />
      
      {/* Modal */}
      <GamelistModal dets={modalDets} gameInfo={gameData} />
    </Box>
  );
}

export default Gamelist;
